module.exports = __webpack_public_path__ + "img/004-wind-10.950e616f.svg";